<template>
  <div id="change-due-date-dialog">
    <ipub-model :title="'Edit Review Due Date'"
                width="470px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p3 mar-b-10">
        Review Due Date
      </div>
      <ipub-date-picker class="mar-b-20"
                        placeholder="Review Due Date"
                        v-model="reviewDueTime" />
      <ipub-radio :checked="autoSend"
                  @change="()=>{autoSend = !autoSend}">
        Automatically send default email
      </ipub-radio>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { minvitedReviewer } from '@/api/reviewer'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      reviewDueTime: '',
      autoSend: true,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.reviewDueTime = ''
        help.closeAutocomplete()
      } else {
        this.reviewDueTime = this.inputData.reviewDueTime
        help.closeAutocomplete()
      }
    }
  },
  methods: {
    onCheckChange (e, id) {
      if (e) {
        return
      }
      this.params.editorId = id
    },
    async confirm () {
      if (this.autoSend) {
        // console.log(this.inputData, 'vvv')
        this.inputData.reviewDueTime = this.reviewDueTime
        this.inputData.autoSend = this.autoSend
        this.$emit('sendEmail', JSON.parse(JSON.stringify(this.inputData)))
      } else {
        await minvitedReviewer.time(this.inputData.id, {
          reviewDueTime: this.reviewDueTime,
          version: this.inputData.version,
          autoSend: this.autoSend
        })
        this.$message.success({ title: 'Success', content: `This Review Due Date has been saved!` })
        this.$emit('confirm')

      }
      // await minvitedReviewer.time(this.inputData.id, {
      //   reviewDueTime: this.reviewDueTime,
      //   version: this.inputData.version,
      //   autoSend: this.autoSend
      // })
      // this.$message.success({ title: 'Success', content: `This Review Due Date has been saved!` })

      // this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
